import React, { FC, useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  message,
  Table,
  Tag,
  Typography,
} from "antd";
import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";
import {
  GetDataOrderListData,
  GetDataOrderListItems,
  GetOrderDetailData,
} from "services/interface";
import { formatDate, formatDateWithTime } from "utils/dateFormat";
import { calculateTimeDifference, getPaymentName, getPaymentStatusName } from "utils/convertData";
import ModalOderDetail from "./ModalOrderDetail";
// import { useGetOrderDetail } from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setLoading } from "store/slices/loadingSlice";
import { useGetOrderDetail, useUpdateReadOrder } from "hooks/useOrders";
import { setDataNewOrdersLimit, setDataNewOrdersOffset, setLastDate } from "store/slices/orderSlice";
import { useNavigate, useParams } from "react-router-dom";
import ModalUpdateOrder from "./ModalUpdateOrder";
import { numberFormat } from "utils/nuberFormat";
import ModalRefundPayment from "./ModalRefundPayment";
import moment from "moment";
import { circleBadge } from "assets/icons";
import { updateReadOrder } from "@/services/ordersApi";
import { RetailPickupCompleteCell } from "../RetailPickupCompleteCell";


interface OrderTableListProps {
  data?: GetDataOrderListData;
  IsHiddenPersonInfo?: boolean;
  refetchData: () => void;
  childrenBank: React.ReactNode[];
  refetchPrepare?: () => void;
  refetchCancel?: () => void;
  refetchCredit?: () => void;
  factory_id: string;
  selectedRowKeys?: React.Key[];
  onSelectChange?: (keys: React.Key[]) => void;
}

const OrderTableList: FC<OrderTableListProps> = ({
  data,
  IsHiddenPersonInfo,
  refetchData,
  childrenBank,
  refetchPrepare,
  refetchCancel,
  refetchCredit,
  factory_id,
  selectedRowKeys,
  onSelectChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tabsKey = 0;

  const [orderId, setOrderId] = useState<string>('');

  const { mutate: readOrder } = useUpdateReadOrder();
  const { order_id: orderIdFromParams } = useParams<{ order_id?: string }>();

  const offset = useAppSelector((state) => state.order.dataNewOrders.offset);
  const limit = useAppSelector((state) => state.order.dataNewOrders.limit);

  const lastDate = useAppSelector((state) => state.order.lastDate);

  const [showDetail, setShowDetail] = useState(false);
  const openedOrderIdRef = useRef<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [refId, setRefId] = useState<string>('')
  const [refType, setRefType] = useState<string>('')

  const [showEdit, setShowEdit] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [orderDetail, setOrderDetail] = useState<GetDataOrderListItems>();

  const showEditModal = (order_id: string, ref_id: string) => {
    setShowEdit(true);
  }

  const [currentTime, setCurrentTime] = useState(moment());

    const contactData = useAppSelector((state) => state.auth.contact);
    const use_platform_transport = contactData?.use_platform_transport;
  

  const forceOpenDetail = (order_id: string, is_problem: boolean, payment_status: string, payment_amount: number, final_price: number) => {
    dispatch(setLoading(true));

    mutate(
      {
        key_type: "order_id",
        group_by: "factory",
        items: [order_id],
        factory_id: factory_id,
      },
      {
        onSuccess: async (data) => {
          // setModalData(data.data[0]);
          setModalData({ ...data.data[0], payment_amount: payment_amount, final_price: final_price });
          setIsProductProblem(is_problem);

          await new Promise((resolve) => setTimeout(resolve, 200));

          dispatch(setLoading(false));

          setShowDetail(true);
        },
        onError: (error) => {
          console.log(error);
          dispatch(setLoading(false));
        },
      })
  }
  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 60000);

    dispatch(setDataNewOrdersLimit(10));
    dispatch(setDataNewOrdersOffset(0));

    return () => clearInterval(interval);
  }, []);

  const [modalData, setModalData] = useState<GetOrderDetailData>();

  const { mutate } = useGetOrderDetail();

  const [isProductProblem, setIsProductProblem] = useState<boolean>(false);

  useEffect(() => {
    if (orderIdFromParams) {
      setOrderId(orderIdFromParams)
    }
  }, [orderIdFromParams]);

  useEffect(() => {
    if (orderId && orderDetail) {
      // modal เปิดอยู่แล้วของออเดอร์นี้ — อัปเดตยอดชำระจาก list (webhook refetch)
      // โดยไม่เปิดซ้ำ / ไม่ทับ paid_amt ด้วยค่าตอนเปิด modal
      if (showDetail && openedOrderIdRef.current === orderId) {
        setModalData((prev) => {
          if (!prev || prev.order_id !== orderId) return prev;
          const listPaid = Number(orderDetail.payment_amount ?? 0);
          const prevPaid = Number(prev.paid_amt ?? 0);
          // ไม่ regress ยอดถ้า list ยัง cache ค่าเก่าอยู่ — webhook เก็บเงินแล้ว paid_amt จะมากกว่าเดิม
          const nextPaid = Math.max(listPaid, prevPaid);
          return {
            ...prev,
            paid_amt: nextPaid,
            payment_amount: nextPaid,
            payment_status: orderDetail.payment_status ?? prev.payment_status,
          };
        });
        return;
      }

      // ปิด modal อยู่แล้วของออเดอร์เดิม — อย่าเปิดซ้ำเพราะ list refresh จาก websocket
      if (openedOrderIdRef.current === orderId && !showDetail) {
        return;
      }

      openedOrderIdRef.current = orderId;
      dispatch(setLoading(true));

      mutate(
        {
          key_type: "order_id",
          group_by: "factory",
          items: [orderId],
          factory_id: factory_id,
        },
        {
          onSuccess: async (data) => {
            if (data?.data?.length > 0) {
              const dataNew = data.data[0];
              console.log('orderDetail999', orderDetail);
              console.log('dataNew999', dataNew);
              let restPrice = -((orderDetail.total_order_price + orderDetail.transport_price) - (orderDetail.discount_amount + orderDetail.payment_amount + orderDetail.pay_point));

              const nextPaid = Number(dataNew.paid_amt ?? orderDetail.payment_amount ?? 0);
              setModalData({
                ...dataNew,
                paid_amt: nextPaid,
                payment_status: dataNew.payment_status ?? orderDetail.payment_status,
                payment_amount: nextPaid,
                final_price: restPrice,
              });

              setRefId(orderDetail.ref_id);
              setRefType(orderDetail.ref_type);

              setIsProductProblem(orderDetail.is_problem);

              await new Promise((resolve) => setTimeout(resolve, 200));
              dispatch(setLoading(false));

              setShowDetail(true);

              !orderDetail.is_read && readOrder(
                {
                  order_id: orderDetail.order_id,
                },
                {
                  onSuccess: async (data) => {
                    refetchData();
                  },
                  onError: (error) => {
                    console.log(error);
                  },
                }
              );
            } else {
              message.error("คำสั่งซื้อไม่ถูกต้อง ลองใหม่อีกครั้ง")
              dispatch(setLoading(false));
            }
          },
          onError: (error) => {
            console.log(error);
            dispatch(setLoading(false));
          },
        })
    }
  }, [orderId, orderDetail, showDetail]);

  useEffect(() => {
    if (data?.order_data) {
      console.log('data999', data?.order_data);
      console.log('orderId999', orderId);
      const dataFind = data?.order_data.find((item: any) => item.order_id === orderId);
      console.log('dataFind999', dataFind);
      setOrderDetail(dataFind);
    }
  }, [data?.order_data]);

  // หมายเหตุ: forceRefreshOrderPayment listener ย้ายไปอยู่ใน ModalOrderDetail แล้ว
  // เพราะ showDetail ของ OrderTableList instance ที่รับ event อาจไม่ใช่ instance ที่ modal เปิดอยู่
  // (หลาย tab mount OrderTableList พร้อมกัน → listener ผิด instance → showDetail: false เสมอ)

  const columns: ColumnsType<GetDataOrderListItems> = [
    {
      title: "Order No.",
      dataIndex: "order_code",
      key: "order_id",
      render: (_text, record) => {
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
        return (
          <Typography.Link
            style={{
              display: "flex", alignItems: "center", margin: 0, padding: 0,
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline"
            }}
            type="secondary"
            onClick={async () => {
              dispatch(setLoading(true));

              mutate(
                {
                  key_type: "order_id",
                  group_by: "factory",
                  items: [record.order_id],
                  factory_id: factory_id,
                },
                {
                  onSuccess: async (data) => {
                    if (data?.data?.length > 0) {
                      const dataNew = data.data[0];
                      const nextPaid = Number(dataNew.paid_amt ?? record.payment_amount ?? 0);
                      openedOrderIdRef.current = record.order_id;
                      setModalData({
                        ...dataNew,
                        paid_amt: nextPaid,
                        payment_status: dataNew.payment_status ?? record.payment_status,
                        payment_amount: nextPaid,
                        final_price: restPrice,
                      });

                      setRefId(record.ref_id);
                      setRefType(record.ref_type);

                      setIsProductProblem(record.is_problem);

                      await new Promise((resolve) => setTimeout(resolve, 200));
                      dispatch(setLoading(false));

                      setShowDetail(true);

                      !record.is_read && readOrder(
                        {
                          order_id: record.order_id,
                        },
                        {
                          onSuccess: async (data) => {
                            refetchData();
                          },
                          onError: (error) => {
                            console.log(error);
                          },
                        }
                      );
                    } else {
                      message.error("คำสั่งซื้อไม่ถูกต้อง ลองใหม่อีกครั้ง")
                      dispatch(setLoading(false));
                    }
                  },
                  onError: (error) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                })
            }}
          >
            {record.is_read === false ?
              circleBadge("red")
              :
              circleBadge("green")
            }
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      // title: 'เวลา',
      // dataIndex: 'order_date',
      render: (_text, record) => {
        return <Typography >
          {_text ? (
            <>
              {calculateTimeDifference(record.order_date, currentTime)}
            </>
          ) : '-'}
        </Typography>
      },
    },
    {
      title: "วันที่สั่งซื้อ",
      dataIndex: "order_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDateWithTime(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "วันที่ต้องส่งสินค้า",
      dataIndex: "due_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDate(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "ชื่อผู้ซื้อ",
      dataIndex: "ref_name",
      key: "ref_name",
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
              maxWidth: "180px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "inline-block",
            }}
            type="secondary"
            onClick={() => {
              if (record.ref_type === "agent") {
                navigate(`/manage-agent/update-agent/${record.ref_id}?section=order&t=${tabsKey}`);
              } else if (record.ref_type === "retail") {
                navigate(`/manage-agent/update-retail/${record.ref_id}?section=order&t=${tabsKey}`);
              }
            }}
          >
            {_text ?? ''}
            <Typography.Text className="text-order-agent-name">
              {" "}{record && record.ref_alias ? `(${record.ref_alias})` : ''}
            </Typography.Text>
          </Typography.Link>
        );
      },
    },
    /*{
      title: "ประเภทลูกค้า",
      dataIndex: "ref_type",
      key: "ref_type",
      render: (_text) => {
        return <Typography>{_text ?? ''}</Typography>;
      },
    },*/
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "ref_telephone",
      key: "ref_telephone",
      render: (_text) => {
        return <Typography>{_text}</Typography>;
      },
    },
    /*{
      title: "ประเภทการขนส่ง",
      width: "100px",
      dataIndex: "transport_name",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },*/
    {
      title: "ช่องทางการสั่งซื้อ",
      width: "100px",
      dataIndex: "datasource_text",
      key: "datasource_text",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },
    {
      title: "ประเภทการชำระเงิน",
      width: "100px",
      dataIndex: "payment_type",
      key: "payment_type",
      render: (_text) => {
        return (
          <Typography style={_text === "COD" ? { color: "#ff4d4f" } : undefined}>
            {getPaymentName(_text, "en")}
          </Typography>
        );
      },
    },
    {
      title: "ราคารวม",
      dataIndex: "result_price",
      render: (_text) => {
        return (
          <Typography>
            {numberFormat(_text)}
          </Typography>
        );
      },
    },
    {
      title: "เครดิตที่ใช้ (COD)",
      dataIndex: "cod_credit_reserved_amount",
      key: "cod_credit_reserved_amount",
      render: (_text, record) => {
        // จองเครดิตตั้งแต่สร้างออเดอร์แล้ว (ไม่ใช่ตอน accept) — cod_credit_reserved_amount มีค่าเฉพาะ
        // ออเดอร์ COD เท่านั้น ดู migration/2026-08-10_cod_credit_reserve_at_creation.md
        if (record.payment_type !== "COD" || record.cod_credit_reserved_amount == null) {
          return <Typography>-</Typography>;
        }
        const isBlocked = record.cod_credit_has_debt === true;
        return (
          <Typography style={isBlocked ? { color: "#ff4d4f" } : undefined}>
            {numberFormat(record.cod_credit_reserved_amount)}
            {isBlocked && (
              <Tag color="red" style={{ marginLeft: 6 }}>
                เครดิตไม่พอ
              </Tag>
            )}
          </Typography>
        );
      },
    },
    {
      title: "สถานะการชำระเงิน",
      dataIndex: "payment_status",
      key: "status_label",
      render: (_text, record) => {
        // 30/9/2026 — ป้าย "ชำระเงินเกิน" (ม่วง) เหลือเฉพาะออเดอร์เงินโอน (manual_transfer)
        // ซึ่งเป็นเคสเดียวที่โรงงานต้องคืนเงินส่วนเกินให้ลูกค้าเอง · ประเภทอื่น (COD / ตัดบัตร /
        // wallet) เงินส่วนเกินไม่ใช่งานของโรงงาน และออเดอร์ที่สินค้าถูกยกเลิกจนยอดรวมเหลือ 0
        // แต่ลูกค้าจ่ายมาแล้ว เคยขึ้นป้ายม่วงทั้งที่ไม่มีอะไรผิด · เทียบแบบ lower-case เพราะ
        // payment_type บนสายเป็น "COD" ตัวใหญ่แต่ "manual_transfer" ตัวเล็ก (EPaymentType)
        const statusName = getPaymentStatusName(_text);
        const isManualTransfer = record.payment_type?.toLowerCase() === "manual_transfer";
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + (record.payment_amount ) + record.pay_point));
        return (
          <Typography>
            {isManualTransfer && restPrice > 0 ? (
              <Tag color="magenta">ชำระเงินเกิน</Tag>
            ) : (
              <Tag color={statusName?.color}>{statusName?.th}</Tag>
            )}
          </Typography>
        );
      },
    },
    {
      title: "ยอดเงินค้างชำระ",
      key: "rest_price",
      dataIndex: "rest_price",
      render: (_text, record) => {
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + (record.payment_amount) + record.pay_point));
              const isManualTransfer = record.payment_type?.toLowerCase() === "manual_transfer";
        return (
          <>
            {/* 30/9/2026 — คู่กับป้ายสถานะ: ยอดที่จ่ายเกินโชว์เฉพาะออเดอร์เงินโอน
                (manual_transfer) ที่โรงงานต้องคืนเงินเอง · ประเภทอื่นขึ้น "-" เหมือนเคสจ่ายพอดี
                เพราะช่องนี้คือ "ยอดค้างชำระ" และออเดอร์ที่จ่ายเกินไม่มียอดค้าง */}
            {restPrice > 0 && isManualTransfer && (
              <Typography>
                {numberFormat(restPrice)}
              </Typography>
            )}
            {(restPrice === 0 || (restPrice > 0 && !isManualTransfer)) && (
              <Typography>
                -
              </Typography>
            )}
            {restPrice < 0 && (
              <Typography style={{ color: 'red' }}>
                {numberFormat(restPrice)}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      title: "จังหวัดปลายทาง",
      dataIndex: "province_name",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },
    {
      title: "คืนเงิน",
      key: "refund",
      align: "center",
      width: 100,
      fixed: 'right',
      render: (_text, record) => {
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + (record.payment_amount )));
        return (
          <>
            {restPrice > 0 && (
              <Button
                type="default"
                size="small"
                style={{
                  fontSize: '10px'
                }}
                onClick={() => {
                  dispatch(setLoading(true));

                  mutate(
                    {
                      key_type: "order_id",
                      group_by: "factory",
                      items: [record.order_id],
                    },
                    {
                      onSuccess: async (data) => {
                        setModalData({ ...data.data[0], payment_status: record.payment_status, final_price: restPrice });

                        await new Promise((resolve) => setTimeout(resolve, 200));

                        dispatch(setLoading(false));

                        setShowRefund(true);
                      },
                      onError: (error) => {
                        console.log(error);
                        dispatch(setLoading(false));
                      },
                    }
                  );
                }}
              >
                คืนเงิน
              </Button>
            )}
          </>
        )
      }
    },
    // {
    //   title: "จุดจำหน่าย",
    //   key: "retail_pickup_complete",
    //   align: "center",
    //   width: 176,
    //   fixed: "right",
    //   render: (_text, record) => (
    //     <RetailPickupCompleteCell
    //       record={record}
    //       onSuccess={() => {
    //         refetchData();
    //         refetchPrepare?.();
    //       }}
    //     />
    //   ),
    // },

  ];

  let filtersColumns: (
    | ColumnGroupType<GetDataOrderListItems>
    | ColumnType<GetDataOrderListItems>
  )[] = columns;
  if (IsHiddenPersonInfo) {
    filtersColumns = columns.filter(
      (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
    );
  }

    if (!use_platform_transport) {
    filtersColumns = filtersColumns.filter(
      (column) => column.key !== "status_label"
    );
  }

  if (use_platform_transport) {
    filtersColumns = filtersColumns.filter(
    //  (column) => column.key !== "datasource_text" && column.key !== "rest_price" && column.key !== "refund" && column.key !== "payment_type"
      (column) => column.key !== "datasource_text" && column.key !== "rest_price" && column.key !== "refund" 
    );
  }


  const [animatedRows, setAnimatedRows] = useState<Set<string>>(new Set());

  // useEffect(() => {
  //   const lastDateData = new Date(lastDate).getTime(); // Get lastDate from the store and convert to milliseconds
  //   if (data?.order_data?.length) {
  //     // const currentTime = new Date().getTime(); // Get current time in milliseconds

  //     const filteredRows = data.order_data
  //       .filter(item => new Date(item.order_date).getTime() > lastDateData) // Filter rows based on order_date being greater than lastDate
  //       .map(item => item.order_id); // Extract order_id from filtered rows

  //     setAnimatedRows(new Set(filteredRows)); // Update state with filtered rows

  //     // Update lastDate with the current time after filtering
  //     dispatch(setLastDate(new Date().toISOString()));
  //   }
  // }, [data]);

  const getRowClassName = (record: GetDataOrderListItems, index: number) => {
    // let className = "";
    // if (animatedRows.has(record.order_id)) {
    //   className += " animate-slide-in highlight-row";
    // } else {
    //   className += " normal-row";
    // }
    const className = "normal-row";

    return className;
  };

  // ออเดอร์ COD ที่ออเดอร์นั้นเองยังมีหนี้ค้าง (cod_credit_has_debt) — ห้ามเลือกไปรับพร้อมกัน
  const isCreditBlockedRow = (record: GetDataOrderListItems) =>
    record.payment_type === "COD" && record.cod_credit_has_debt === true;

  const rowSelection =
    selectedRowKeys !== undefined && onSelectChange
      ? {
          selectedRowKeys,
          onChange: onSelectChange,
          preserveSelectedRowKeys: true,
          getCheckboxProps: (record: GetDataOrderListItems) => ({
            disabled: isCreditBlockedRow(record),
          }),
          // เครดิตไม่พอ / มียอดหนี้ → ซ่อน checkbox ไปเลย (ไม่ใช่แค่ disabled) ตามที่ตกลงกันไว้ — เหลือ
          // getCheckboxProps ไว้เป็น safety net เผื่อ renderCell ไม่ทำงานในบางกรณี
          renderCell: (
            _checked: boolean,
            record: GetDataOrderListItems,
            _index: number,
            originNode: React.ReactNode
          ) => (isCreditBlockedRow(record) ? null : originNode),
        }
      : undefined;

  return (
    <div>
      <Table
        onRow={(record) => {
          return {
            onClick: () => {
              // setShowDetail(true);
              console.log(record.is_read)

            },
          };
        }}
        rowKey="order_id"
        size="small"
        rowSelection={rowSelection}
        columns={filtersColumns}
        // scroll={{ y: 500, x: true }}
        dataSource={data?.order_data}
        scroll={{ x: true }}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            dispatch(setDataNewOrdersOffset(pageSize! * (page! - 1)));
            dispatch(setDataNewOrdersLimit(pageSize!));
          },
        }}
        rowClassName={getRowClassName}
      />
      <ModalOderDetail
        open={showDetail}
        onClose={() => {
          setShowDetail(false);
          // form.resetFields();
        }}
        item={modalData as GetOrderDetailData}
        childrenBank={childrenBank}
        refetchData={refetchData}
        statusPage="new_order"
        showEditModal={showEditModal}
        isProductProblem={isProductProblem}
        refetchPrepare={refetchPrepare}
        refetchCancel={refetchCancel}
      />
      <ModalUpdateOrder
        refId={refId}
        refType={refType}
        open={showEdit}
        item={modalData as GetOrderDetailData}
        setOpen={setShowEdit}
        refetchData={refetchData}
        isProductProblem={isProductProblem}
        forceOpen={forceOpenDetail}
      />
      <ModalRefundPayment
        open={showRefund}
        refund_process={"overpay"}
        onClose={() => {
          setShowRefund(false);
        }}
        item={modalData as GetOrderDetailData}
        refetchData={refetchData}
      />
    </div>
  );
};

export default OrderTableList;

